module.exports = __webpack_public_path__ + "7262591ce00197b9696afb2b5dcfa4bd.png";